import React from 'react'

export const ThanksPage = () => {
    return(
        <div className="container thanksContainer">
            <h1 className="thanksText">
                <span>T</span>
                <span>h</span>
                <span>a</span>
                <span>n</span>
                <span>k</span>
                <span>Y</span>
                <span>o</span>
                <span>u</span>
                <span>!</span>
            </h1>
        </div>
      )
} 